import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { authGuard, authGuardChild } from './shared/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [authGuardChild],
    loadComponent: () =>
      import('./layout/default-layout/default-layout.component').then(
        m => m.DefaultLayoutComponent
      ),
    loadChildren: () =>
      import('./module/default/default-routing.module').then(
        m => m.DEFAULT_ROUTES
      ),
  },
  {
    path: 'auth',
    loadComponent: () =>
      import('./layout/auth-layout/auth-layout.component').then(
        m => m.AuthLayoutComponent
      ),
    loadChildren: () =>
      import('./module/login/login-routing.module').then(m => m.LOGIN_ROUTES),
  },
  {
    path: 'uploads-preview',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        './module/default/image-preview-album/image-preview-album.component'
      ).then(m => m.ImagePreviewAlbumComponent),
  },
  {
    path: '**',
    loadComponent: () =>
      import(
        './shared/components/page-not-found/page-not-found.component'
      ).then(m => m.PageNotFoundComponent),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
